import React, { Component } from 'react';
import '../global';
// import { fetchCart, updateCart } from '../actions';
import { connect } from 'react-redux';
import { updateFormErrors } from '../actions';

class CheckoutAddressShipping extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			_checkout_shipping_address    : '',
			_checkout_shipping_address_two: '',
			_checkout_shipping_country    : '',
			_checkout_shipping_city       : '',
			_checkout_shipping_state      : '',
			_checkout_shipping_postal_code: ''
		};
		const { countries } = getCartInfo();
		this.countries = countries;
		this.handleChange = this.handleChange.bind( this );
		this.handleBlur = this.handleBlur.bind( this );
	}

	handleChange( event ) {
		const { name, value } = event.target;
		this.setState( { [ name ]: value } );
	}

	handleBlur( event ) {
		const { name, value } = event.target;

		// Create a new object from the current form errors
		const newFormErrors = { ...this.props.form_errors };

		if ( value === '' ) {
			newFormErrors[ name ] = 'This is a required field.';
		} else {
			// Remove the field if it exists
			delete newFormErrors[ name ];
		}

		// Update form errors with the new object
		this.props.updateFormErrors( newFormErrors );
	}

	render() {
		return (<div className="form-container">
				<div class="row">
					<div
						class={ `form-group col-sm-12 ${ this.props.form_errors._checkout_shipping_address
						                                 ? 'has-error has-danger'
						                                 : '' }` }>
						<label for="checkout-shipping-address">Address <span
							aria-hidden="true">*</span></label>
						<input
							type="text"
							name="_checkout_shipping_address"
							class="form-control"
							id="checkout-shipping-address"
							required="required"
							placeholder="Street number and street name"
							value={ this.state._checkout_shipping_address }
							onChange={ this.handleChange }
							onBlur={ this.handleBlur }
						/>
						<div
							class="help-block with-errors">{ this.props.form_errors._checkout_shipping_address }</div>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-sm-12">
						<label for="checkout-shipping-address-two">Address Line
							Two</label>
						<input
							type="text"
							name="_checkout_shipping_address_two"
							id="checkout-shipping-address-two"
							class="form-control"
							placeholder="Apartment, suite, floor..."
							value={ this.state._checkout_shipping_address_two }
							onChange={ this.handleChange }
						/>
						<div class="help-block with-errors"></div>
					</div>
				</div>
				<div class="row">
					<div
						class={ `form-group col-sm-6 ${ this.props.form_errors._checkout_shipping_country
						                                ? 'has-error has-danger'
						                                : '' }` }>
						<label for="checkout-shipping-country">Country <span
							aria-hidden="true">*</span></label>
						<select
							class="form-control country"
							id="checkout-shipping-country"
							name="_checkout_shipping_country"
							required="required"
							data-regionElement="checkout-shipping-state"
							value={ this.state._checkout_shipping_country }
							onChange={ this.handleChange }
							onBlur={ this.handleBlur }
						>
							<option value="">Select a country</option>
							{ this.countries.map( ( country ) => (<option
									value={ country.CountryName }>{ country.CountryName }</option>
							) ) }
						</select>
						<div
							class="help-block with-errors">{ this.props.form_errors._checkout_shipping_country }</div>
					</div>
					<div
						class={ `form-group col-sm-6 ${ this.props.form_errors._checkout_shipping_city
						                                ? 'has-error has-danger'
						                                : '' }` }>
						<label for="checkout-shipping-city">City <span
							aria-hidden="true">*</span></label>
						<input
							type="text"
							name="_checkout_shipping_city"
							class="form-control"
							id="checkout-shipping-city"
							required="required"
							value={ this.state._checkout_shipping_city }
							onChange={ this.handleChange }
							onBlur={ this.handleBlur }
						/>
						<div
							class="help-block with-errors">{ this.props.form_errors._checkout_shipping_city }</div>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-sm-6">
						<label
							for="checkout-shipping-state">State/Province</label>
						<select
							class="form-control"
							id="checkout-shipping-state"
							name="_checkout_shipping_state"
							value={ this.state._checkout_shipping_state }
							onChange={ this.handleChange }
						>
							<option value="">Select a state</option>
						</select>
						<div
							class="help-block with-errors">{ this.props.form_errors._checkout_shipping_state }</div>
					</div>
					<div
						class={ `form-group col-sm-6 ${ this.props.form_errors._checkout_shipping_postal_code
						                                ? 'has-error has-danger'
						                                : '' }` }>
						<label for="checkout-shipping-postal-code">Zip/Postal
							Code <span aria-hidden="true">*</span></label>
						<input
							type="text"
							name="_checkout_shipping_postal_code"
							class="form-control"
							id="checkout-shipping-postal-code"
							required="required"
							value={ this.state._checkout_shipping_postal_code }
							onChange={ this.handleChange }
							onBlur={ this.handleBlur }
						/>
						<div
							class="help-block with-errors">{ this.props.form_errors._checkout_shipping_postal_code }</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps( { form_errors } ) {
	return {
		form_errors
	};
}

export default connect( mapStateToProps, { updateFormErrors } )( CheckoutAddressShipping );